import React from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { App } from "./App.js";
import { appStore, playbackStore, dialogStore, toastStore } from "./store.js";
import { start } from "./controller.js";

// Dialog workflows require the new form to exist before binding its file controls.
// Commit all store notifications synchronously, including navigation before focus.
for (const store of [appStore, playbackStore, dialogStore, toastStore])
  store.setCommit(flushSync);
const element = document.getElementById("root");
if (!element) throw new Error("Crate could not find its app root.");
const root = createRoot(element);
flushSync(() => root.render(<App />));
start();
